import { render, staticRenderFns } from "./YoutubeStreamModal.vue?vue&type=template&id=47961f95&scoped=true&"
import script from "./YoutubeStreamModal.vue?vue&type=script&lang=js&"
export * from "./YoutubeStreamModal.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeStreamModal.vue?vue&type=style&index=0&id=47961f95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47961f95",
  null
  
)

export default component.exports